<template>
    <v-card flat class="site-title">
        <transition name="slide-fade">
            <v-card-title class="page-title" v-if="showTitle">Marketing</v-card-title>
        </transition>
    </v-card>
    <v-card flat class="site-wrapper">
        <v-row>
        <v-col cols="6">
            <PagePreviewGallery></PagePreviewGallery>
        </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" sm="4">
                <AgenciesWithFreeSlots></AgenciesWithFreeSlots>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <slotPriceCalculator></slotPriceCalculator>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <SlotModels></SlotModels>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
import AgenciesWithFreeSlots from './searchFields/AgenciesWithAmountFreeSlots.vue';
import slotPriceCalculator from './slots/slotPriceCalculator.vue';
import SlotModels from './slots/SlotModels.vue';
import PagePreviewGallery from './pagesData/PagePreviewGallery.vue';
import { mapState, mapActions } from 'vuex';

export default {
    data() {
        return {
            showTitle: false,
        };
    },
    methods: {
        ...mapActions('marketing', ['getPriceModels']),
        async loadModels() {
            this.models = await this.$store.dispatch('marketing/getPriceModels');
        }
    },
    components: {
        AgenciesWithFreeSlots,
        slotPriceCalculator,
        SlotModels,
        PagePreviewGallery,
    },
    computed: {
        ...mapState('marketing', ['loading'])
    },
    mounted() {
        this.showTitle = true;
    },
    created() {
        this.loadModels();
    },
};
</script>

<style lang="scss" scoped>
.marketing-wrapper-left {
    margin: 10px;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 12px;
}

.marketing-wrapper-middle {
    margin: 10px;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 12px;
}

.marketing-wrapper-right {
    margin: 10px;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 12px;
}
</style>